<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    class="pay-card"
  >
    <el-row
      type="flex"
      class="pay-card-header"
    >
      <div
        class="pay-card-header-back-button"
        @click="$router.go(-1)"
      >
        <img
          src="@/assets/img/icons/back-btn.png"
          alt="back"
        >
      </div>
      <div class="pay-card-header-title">
        <span class="pay-card-header-title-text">
          {{ $t('pay.total-amount') }}
        </span>
        <span class="pay-card-header-title-amount">
          {{
            (paymentInfo.totalAmount / 100).toLocaleString($localeString, {
              style: 'currency',
              currency: 'EUR'
            })
          }}
        </span>
      </div>
    </el-row>
    <el-form
      :model="paymentForm"
      :rules="paymentForm.rules"
      ref="paymentForm"
      label-position="top"
      class="pay-card-form"
    >
      <el-form-item
        :label="$t('pay.credit-card')"
        class="pay-card-form-field-card"
        prop="creditCard"
      >
        <div id="credit-card" />
        <div class="pay-card-form-field-card-icons">
          <img
            src="@/assets/img/icons/visa.png"
            alt=""
          >
          <img
            src="@/assets/img/icons/mastercard.png"
            alt=""
          >
        </div>
      </el-form-item>
      <div class="row pay-card-form-details">
        <el-form-item
          class="pay-card-form-field-exp"
          prop="cardExp"
        >
          <div id="card-exp" />
        </el-form-item>
        <el-form-item
          class="pay-card-form-field-cvc"
          prop="cardCvc"
        >
          <div id="card-cvc" />
          <div class="pay-card-form-field-cvc-icon">
            <img
              src="@/assets/img/icons/cvc.png"
              alt=""
            >
          </div>
        </el-form-item>
      </div>
      <p
        v-if="creditCard.validationError.length"
        class="invalid"
      >
        {{ creditCard.validationError }}
      </p>
      <el-form-item
        :label="$t('pay.card-holder')"
        prop="cardHolder"
      >
        <el-input
          v-model="paymentForm.cardHolder"
        />
      </el-form-item>
      <el-form-item
        :label="$t('pay.region')"
        prop="region"
      >
        <el-select
          v-model="paymentForm.region"
        >
          <el-option
            v-for="(country, index) in getCountries"
            :key="index"
            :label="country.name"
            :value="index"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        class="pay-card-form-terms"
        prop="terms"
      >
        <el-checkbox-group
          v-model="paymentForm.terms"
        >
          <el-checkbox :label="true">
            <i18n path="pay.user-terms">
              <template v-slot:termsLink>
                <router-link
                  class="terms-link"
                  :to="{name: 'CustomerTerms'}"
                  target="_blank"
                >
                  {{ $t('pay.user-terms-link') }}
                </router-link>
              </template>
            </i18n>
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item class="pay-card-form-button">
        <el-button
          type="primary"
          class="primary-button"
          @click="submitForm('paymentForm')"
        >
          {{ $t('pay.title') }}
        </el-button>
      </el-form-item>
    </el-form>
    <div class="pay-card-powered-by">
      <div class="pay-card-powered-by-title">
        <span>
          {{ $t('pay.stripe.powered-by') }}
          <img
            src="@/assets/img/icons/stripe.png"
            alt=""
          >
        </span>
      </div>
      <div class="pay-card-powered-by-links">
        <a href="https://stripe.com/checkout/terms">{{ $t('pay.stripe.conditions') }}</a>
        <a href="https://stripe.com/privacy">{{ $t('pay.stripe.privacy') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { countries } from 'countries-list';

export default {
  name: 'PayCard',
  data: function () {
    return {
      fullScreenLoading: true,
      paymentInfo: {
        currency: this.$route.params.currency,
        totalAmount: Number(this.$route.params.totalAmount),
        qrCode: this.$route.params.qrCode,
        clientPaysFee: !!this.$route.params.clientPaysFee
      },
      paymentForm: {
        cardNumber: {},
        cardExpiry: {},
        cardCvc: {},
        cardHolder: '',
        region: 'DE',
        terms: [true]
      },
      creditCard: {
        style: {
          base: {
            iconColor: '#B5B5B5',
            color: '#2D2E2F',
            fontSize: '16px',
            fontFamily: '"Raleway Regular"',
            '::placeholder': {
              color: '#A3A4AC'
            }
          },
          invalid: {
            color: '#F56C6C',
            iconColor: '#F56C6C'
          }
        },
        validationError: ''
      },
      stripe: {},
      confirmDialog: {
        src: '',
        visible: false
      }
    };
  },
  computed: {
    getCountries: {
      get: function () {
        return countries;
      }
    },
    getFormRules: () => {
      return {
        cardHolder: [
          {
            required: true,
            message: this.$t('form.validation.required', { field: this.$t('pay.card-holder') }),
            trigger: 'blur'
          }
        ],
        region: [
          {
            required: true,
            message: this.$t('form.validation.required', { field: this.$t('profile.country') }),
            trigger: 'change'
          }
        ],
        terms: [
          {
            type: 'array',
            required: true,
            message: this.$t('form.validation.required', { field: this.$t('pay.user-terms-link') }),
            trigger: 'change'
          }
        ]
      };
    }
  },
  created () {
    this.$axios.get(`api/v1/teams/qrcodes/${this.$route.params.qrCode}`).then((team) => {
      if (team.data.team) {
        return this.$router.push({
          name: 'SelectEmployee',
          params: { qrCode: this.$route.params.qrCode, currency: this.paymentInfo.currency }
        });
      } else {
        this.$axios.get('/api/v1/qrcodes/' + this.$route.params.qrCode).then((response) => {
          if (response.data.empAssigned) {
            this.paymentInfo = { ...this.paymentInfo, ...response.data };
            this.createCreditCardElement();
          } else {
            this.$message.error({
              message: this.$t('form.item-not-found', { item: 'QR Code' }),
              duration: 0
            });
          }
          this.fullScreenLoading = false;
        })
          .catch(() => {
            this.fullScreenLoading = false;
          });
      }
    });
  },
  methods: {
    createCreditCardElement () {
      //Create Stripe instance
      this.stripe = window.Stripe(process.env.VUE_APP_PAYMENT_STRIPE_PUBLISH_KEY, {
        locale: this.$i18n.locale
      });

      // Create Stripe payment request
      const paymentRequest = this.stripe.paymentRequest({
        country: process.env.VUE_APP_PAYMENT_COUNTRY_CODE,
        currency: this.paymentInfo.currency.toLowerCase(),
        total: {
          label: `${this.$t('pay.tips-for')} ${this.paymentInfo.employee.name} ${this.paymentInfo.employee.surName} in ${this.paymentInfo.businessEntity.name}`,
          amount: this.paymentInfo.totalAmount
        }
      });
      paymentRequest.on('token', this.processPayment);

      const elements = this.stripe.elements();
      //Generate card number element
      this.paymentForm.cardNumber = elements.create('cardNumber', {
        style: this.creditCard.style
      });
      this.paymentForm.cardNumber.mount('#credit-card');

      //Generate card expiration element
      this.paymentForm.cardExpiry = elements.create('cardExpiry', {
        style: this.creditCard.style
      });
      this.paymentForm.cardExpiry.mount('#card-exp');

      //Generate card CVC element
      this.paymentForm.cardCvc = elements.create('cardCvc', {
        style: this.creditCard.style
      });
      this.paymentForm.cardCvc.mount('#card-cvc');

      //Validate credit card element on change event
      this.paymentForm.cardNumber.on('change', (event) => {
        if (event.error) {
          this.creditCard.validationError = event.error.message;
        } else {
          this.creditCard.validationError = '';
        }
      });
      this.paymentForm.cardExpiry.on('change', (event) => {
        if (event.error) {
          this.creditCard.validationError = event.error.message;
        } else {
          this.creditCard.validationError = '';
        }
      });
      this.paymentForm.cardCvc.on('change', (event) => {
        if (event.error) {
          this.creditCard.validationError = event.error.message;
        } else {
          this.creditCard.validationError = '';
        }
      });
    },
    processPayment (paymentData) {
      this.fullScreenLoading = true;

      let queryString = this.$route.fullPath.split('?')[1] || '';
      if (queryString !== '') {
        queryString = '?' + queryString;
      }

      this.$axios.post('/api/v1/tx' + queryString, {
        qrCode: this.paymentInfo.qrCode,
        currency: this.paymentInfo.currency,
        amount: this.paymentInfo.totalAmount,
        clientPaysFee: !!this.paymentInfo.clientPaysFee,
        payData: JSON.stringify(paymentData.token)
      }).then((response) => {
        if (response.data.status === 'Success') {
          if (response.data.payload.nextAction) {
            const self = this;
            this.stripe.confirmCardPayment(response.data.payload.clientSecret, {
                payment_method: { card: this.paymentForm.cardNumber },
                return_url: `${process.env.VUE_APP_BASE_URL}/#/pay-confirm/${self.paymentInfo.qrCode}/${self.paymentInfo.currency}/${self.paymentInfo.totalAmount}/${response.data.payload.txId}`
              },
              { handleActions: false }
            ).then(function (result) {
              if (result.paymentIntent.status === 'succeeded') {
                self.$router.push({ name: 'Receipt', params: { transactionId: response.data.payload.txId } });
              } else if (result.paymentIntent.status === 'requires_action') {
                window.location.href = result.paymentIntent.next_action.redirect_to_url.url;
              } else {
                self.$message.warning(self.$t('pay.not-processed'));
              }
              self.fullScreenLoading = false;
            })
              .catch(() => {
                this.fullScreenLoading = false;
              });
          } else {
            this.fullScreenLoading = false;
            this.$router.push({ name: 'Receipt', params: { transactionId: response.data.payload.txId } });
          }
        } else {
          this.$message.warning(this.$t('pay.not-processed'));
        }
      }).catch(() => {
        this.fullScreenLoading = false;
        this.$message.error(this.$t('form.something-wrong'));
      });
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.createToken();
        } else {
          this.$amplitude.logEvent('Credit card page event Pay button clicked', {
            qrCode: this.paymentInfo.qrCode,
            valid: false,
            message: 'Form is incomplete.'
          });
          return false;
        }
      });
    },
    createToken () {
      this.stripe.createToken(this.paymentForm.cardNumber, {
        name: this.paymentForm.cardHolder,
        address_country: this.paymentForm.region
      }).then((response) => {
        if (response.error) {
          this.creditCard.validationError = response.error.message;
          this.$amplitude.logEvent('Credit card page event Pay button clicked', {
            qrCode: this.paymentInfo.qrCode,
            valid: false,
            message: response.error.message
          });
        } else {
          this.$amplitude.logEvent('Credit card page event Pay button clicked', {
            qrCode: this.paymentInfo.qrCode,
            valid: true,
            message: ''
          });
          this.creditCard.validationError = '';
          this.processPayment(Object.assign(response, { methodName: 'card' }));
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.invalid {
  color: #F56C6C;
}

.pay-card {
  padding: 0 12px;

  &-header {
    margin: 24px 0;
    justify-content: center;

    &-back-button {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translate(0, -50%);
    }

    &-title {
      display: flex;
      flex-direction: column;
      text-align: center;

      &-text {
        color: #2D2E2F;
        font-family: "Raleway SemiBold", serif;
        font-size: 16px;
        margin: 0;
      }

      &-amount {
        color: #2D2E2F;
        font-family: "Raleway Bold", serif;
        font-size: 32px;
        margin: 0;
      }
    }
  }

  &-form {
    &-terms::v-deep {
      margin-bottom: 56px !important;

      .el-checkbox {
        display: flex;
        align-items: center;
        width: 100%;

        &__inner {
          width: 16px;
          height: 16px;
          background: #2D2E2F;
          border: none;
          border-radius: 2px;

          &:after {
            height: 8px;
            width: 4px;
            border: 2px solid #FFFFFF;
            border-left: 0;
            border-top: 0;
            left: 5px;
            top: 2px;
          }
        }

        &__label {
          font-family: "Raleway Medium", serif;
          font-size: 12px;
          line-height: 16px;
          color: #2D2E2F;
          white-space: normal;

          .terms-link {
            color: #B5B5B5;
            text-decoration: underline;
          }
        }
      }
    }

    &-details {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-field {
      &-card::v-deep {
        margin-bottom: 8px !important;

        label {
          &:before {
            content: '*';
            color: #F56C6C;
            margin-right: 4px;
          }
        }
      }

      &-card {
        &-icons {
          display: flex;
          position: absolute;
          right: 17px;
          top: 50%;
          transform: translate(0, -50%);

          img:last-child {
            margin-left: 4px;
          }
        }
      }

      &-exp {
        width: 100%;
      }

      &-cvc {
        width: 100%;
        margin-left: 8px;

        &-icon {
          display: flex;
          position: absolute;
          right: 17px;
          top: 50%;
          transform: translate(0, -50%);
        }
      }
    }
  }

  &-powered-by {
    text-align: center;
    margin-bottom: 24px;

    &-title {
      span {
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: "Raleway Medium", serif;
        font-size: 12px;
        line-height: 16px;
        color: #A3A4AC;

        img {
          margin-left: 4px;
        }
      }
    }

    &-links {
      margin-top: 8px;

      a {
        font-family: "Raleway Medium", serif;
        font-size: 12px;
        color: #A3A4AC;

        &:first-child {
          margin-right: 12px;
        }
      }
    }
  }
}

#credit-card, #card-exp, #card-cvc {
  border: 1px solid #E3E5E5;
  border-radius: 8px;
  padding: 14px 16px;
}

.el-form-item::v-deep {
  margin-bottom: 24px;

  input {
    font-family: "Raleway Bold", serif;
    font-size: 16px;

    &::placeholder {
      font-family: "Raleway Regular", serif;
    }
  }
}
</style>
